import React from "react";
import RegisterForm from "../components/RegisterForm/RegisterForm";

const RegisterPage = () => {
  return (
    <div className="py-10">
      <RegisterForm />
    </div>
  );
};

export default RegisterPage;
